import { render, staticRenderFns } from "./wronghistory.vue?vue&type=template&id=63706efb&scoped=true"
import script from "./wronghistory.vue?vue&type=script&lang=js"
export * from "./wronghistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63706efb",
  null
  
)

export default component.exports